export default {
    setupNeeds({ commit }, needs) {
        commit('UPDATE', needs);
    },
};
